import React, { useState } from "react";
import { Expand, X, ChevronLeft, ChevronRight, Play } from "lucide-react";
import { galleryItems } from "../mock";
import { Dialog, DialogContent } from "./ui/dialog";

export default function Gallery() {
  const [index, setIndex] = useState(null);
  const open = index !== null;
  const go = (d) => setIndex((i) => (i + d + galleryItems.length) % galleryItems.length);

  return (
    <section id="galeria" className="bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-20 lg:py-28">
        <div className="max-w-2xl reveal">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#1d6fc0]">
            Nuestro centro
          </span>
          <h2 className="font-display font-extrabold text-3xl lg:text-[2.6rem] leading-tight mt-4 text-[#0b2545]">
            Espacios y equipamiento de última generación
          </h2>
          <p className="text-slate-500 mt-4 leading-relaxed">
            Un entorno moderno, seguro y cómodo, diseñado para brindarte la mejor experiencia
            en el cuidado de tu visión.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mt-12">
          {galleryItems.map((g, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              className={`reveal group relative overflow-hidden rounded-2xl ${
                i === 0 ? "col-span-2 lg:col-span-2 lg:row-span-2" : ""
              }`}
              style={{ transitionDelay: `${(i % 3) * 70}ms` }}
            >
              <img
                src={g.poster || g.src}
                alt={g.title}
                className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${
                  i === 0 ? "h-64 lg:h-full min-h-[280px]" : "h-40 lg:h-56"
                }`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#071a33]/80 via-[#071a33]/10 to-transparent opacity-90" />
              {g.type === "video" && (
                <div className="absolute inset-0 grid place-items-center">
                  <span className="w-16 h-16 rounded-full bg-white/90 grid place-items-center shadow-xl group-hover:scale-110 transition-transform">
                    <Play size={26} className="text-[#1d6fc0] ml-1 fill-[#1d6fc0]" />
                  </span>
                </div>
              )}
              <div className="absolute bottom-0 left-0 right-0 p-4 text-left">
                <div className="text-white font-display font-bold text-sm lg:text-base">{g.title}</div>
                <div className="text-blue-100/80 text-xs mt-0.5 line-clamp-1">{g.caption}</div>
              </div>
              <div className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/15 backdrop-blur border border-white/25 grid place-items-center text-white opacity-0 group-hover:opacity-100 transition-opacity">
                {g.type === "video" ? <Play size={16} /> : <Expand size={16} />}
              </div>
            </button>
          ))}
        </div>
        <p className="text-xs text-slate-400 mt-6">
          * Video y fotografías reales de nuestro centro, equipamiento y cirugías en San Fernando.
        </p>
      </div>

      <Dialog open={open} onOpenChange={(o) => !o && setIndex(null)}>
        <DialogContent className="max-w-3xl p-0 overflow-hidden bg-[#071a33] border-none">
          {open && (
            <div className="relative">
              {galleryItems[index].type === "video" ? (
                <video
                  src={galleryItems[index].src}
                  poster={galleryItems[index].poster}
                  controls
                  autoPlay
                  playsInline
                  className="w-full max-h-[70vh] bg-black"
                />
              ) : (
                <img src={galleryItems[index].src} alt={galleryItems[index].title} className="w-full h-[60vh] object-cover" />
              )}
              <button onClick={() => setIndex(null)} className="absolute top-3 right-3 w-10 h-10 rounded-full bg-black/40 text-white grid place-items-center hover:bg-black/60">
                <X size={20} />
              </button>
              <button onClick={() => go(-1)} className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/40 text-white grid place-items-center hover:bg-black/60">
                <ChevronLeft size={22} />
              </button>
              <button onClick={() => go(1)} className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/40 text-white grid place-items-center hover:bg-black/60">
                <ChevronRight size={22} />
              </button>
              <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-[#071a33] to-transparent">
                <div className="text-white font-display font-bold text-lg">{galleryItems[index].title}</div>
                <div className="text-blue-100/80 text-sm">{galleryItems[index].caption}</div>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
}
